import axiosInstance from '@core/utils/axiosInstance';

export interface CrudApi<TEntity, TCreate, TUpdate = Partial<TCreate>> {
  getAll: () => Promise<TEntity[]>;
  getById: (id: number) => Promise<TEntity>;
  create: (data: TCreate) => Promise<TEntity>;
  update: (id: number, data: TUpdate) => Promise<TEntity>;
  delete: (id: number) => Promise<void>;
  reorder: (ids: number[], scope?: Record<string, unknown>) => Promise<void>;
}

export function createCrudApi<TEntity, TCreate, TUpdate = Partial<TCreate>>(
  resource: string
): CrudApi<TEntity, TCreate, TUpdate> {
  return {
    getAll: async () => {
      const { data } = await axiosInstance.get<TEntity[]>(`/${resource}`);
      return data;
    },
    getById: async (id) => {
      const { data } = await axiosInstance.get<TEntity>(`/${resource}/${id}`);
      return data;
    },
    create: async (payload) => {
      const { data } = await axiosInstance.post<TEntity>(
        `/${resource}`,
        payload
      );
      return data;
    },
    update: async (id, payload) => {
      const { data } = await axiosInstance.put<TEntity>(
        `/${resource}/${id}`,
        payload
      );
      return data;
    },
    delete: async (id) => {
      await axiosInstance.delete(`/${resource}/${id}`);
    },
    reorder: async (ids, scope) => {
      await axiosInstance.patch(`/${resource}/reorder`, { ...scope, ids });
    },
  };
}
